import {InventoryUse, Media, Option, Product, Productmeda} from "../bo/product";
import {Asset} from "../bo/asset";

export const sizeRe = /^Size and price|^Flower options/i;

export interface Size {
    value: number;
    description: string | undefined;
    media: Productmeda | undefined;
    optionName: string;
    visible: boolean;
    uses?: InventoryUse[];
}

function valueToNumber(value: number | string | undefined) : number {
    if (value === undefined) {
        return 0;
    }
    // @ts-ignore
    if (! isNaN(value)) {
        return Number(value);
    }
    const valueRe = /\$([0-9]+(\.[0-9]+)?|([0-9]+(\.[0-9]+)))/;
    const match = String(value).match(valueRe);
    if (match) {
        return Number(match[1]);
    }
    return 0;
}

export function getProductSizes(product: Product ) {

    let sizes : Size[] = [];

    if (product.productOptions) {

        const opts = getSizeOption(product);

        if (opts && opts.choices) {
            sizes = opts.choices.map(x => {
                return {
                    value: valueToNumber(x.value),
                    description: x.description,
                    media: x.media,
                    optionName: opts.name as string,
                    visible: x.visible ? true : false,
                    uses: x.uses,
                }
            });
        }
    }

    return sizes;
}

export function getSizeOption(product: Product) : Option | undefined {
    if (product.productOptions) {
        const opts = product.productOptions.filter(x => x.name?.match(sizeRe));
        return opts[0];
    }
    return undefined;
}

export function addProductSize(product: Product, size: Size) {
    let sizes = getProductSizes(product);
    sizes.push(size);
    sizes.sort((a, b) => {
        return valueToNumber(a.value) - valueToNumber(b.value);
    });

    const choices = sizes.map(x => {
        return {
            media: x.media,
            description: x.description,
            value: x.value as any as string,
            visible: x.visible,
            uses: x.uses,
        }
    });

    const sizeOpt = getSizeOption(product);

    if (! sizeOpt) {
        product.productOptions = [{
            name: "Size and price",
            choices: choices
        }];
    } else {
        sizeOpt.choices = choices;
    }
}

export function deleteProductSize(product: Product, name: string) {
    const opt = getSizeOption(product);
    if (opt && opt.choices) {
        const idx = opt.choices.findIndex(c => c.description == name);
        if (idx >= 0) {
            opt.choices.splice(idx, 1);
        }
        if (opt.choices.length == 0) {
            product.visible = false;
        }
    }
}

export function assetToMedia(asset: Asset) : Media {
    const media : Media  = {
        image: {
            url: asset.src,
            height: asset.height,
            width: asset.width
        },
        title: asset.name,
        mediaType: "image"
    };

    const h = asset.height || 500;
    const w = asset.width || 500;
    const m = Math.max(w, h);

    if (asset.web_url) {
        const scale = 100 / m;
        media.image = {
            url: asset.web_url,
            height: Math.round(h * scale),
            width: Math.round(w * scale)
        }
    }

    if (asset.web_url) {
        const scale = 100 / m;
        media.thumbnail = {
            url: asset.thumbnail_url,
            height: Math.round(h * scale),
            width: Math.round(w * scale)
        }
    }

    return media;
}

export const renderName = (product: Product) => {
    let name = product.name || "";
    name = name.replace(/ from \$[0-9]+/i, "");
    return name;
}
